export default "assets/images/teal-texture-c99c82ad.jpg";